export default __webpack_public_path__ + "static/javascript-logo-266bd9fb2663dcc057b43c239a73e01b.png";